module.exports = __webpack_public_path__ + "img/miguel_angel_javier.694d0691.png";